export const GET_CATEGORY = "GET_CATEGORY";
export const SET_CATEGORY = "SET_CATEGORY";
export const CLEAR_CATEGORY = "CLEAR_CATEGORY";
